import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./themes/ThemeContext";
import { SiteSettingsProvider } from "./context/SiteSettingsContext";
import MaintenanceGate from "./components/MaintenanceGate";
import Home from './pages/Home';
import About from './pages/About';
import Tools from './pages/Tools';
import Videos from './pages/Videos';
import Stream from './pages/Stream';
import StreamSubPageRoute from './pages/stream/StreamSubPageRoute';
import Reviews from './pages/Reviews';
import Streamers from './pages/Streamers';
import Contact from './pages/Contact';
import ToolPage from './pages/tools/ToolPage';
import GTA4Challenge from './pages/GTA4Challenge';
import GTA6Challenge from './pages/GTA6Challenge';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminGuard from './pages/admin/AdminGuard';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTools from './pages/admin/AdminTools';
import AdminToolPages from './pages/admin/AdminToolPages';
import AdminStreamPages from './pages/admin/AdminStreamPages';
import AdminReviews from './pages/admin/AdminReviews';
import AdminPages from './pages/admin/AdminPages';
import AdminSchedule from './pages/admin/AdminSchedule';
import AdminStreamers from './pages/admin/AdminStreamers';
import AdminSettings from './pages/admin/AdminSettings';
import AdminMedia from './pages/admin/AdminMedia';
import ScrollToTop from './components/ScrollToTop';
import "./styles.css";

function App() {
  return (
    <ThemeProvider>
      <SiteSettingsProvider>
        <Router>
          <ScrollToTop />
          <MaintenanceGate>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/shop" element={<Tools />} />
              <Route path="/tools" element={<Tools />} />
              <Route path="/tools/:slug" element={<ToolPage />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/stream" element={<Stream />} />
              <Route path="/games" element={<Reviews />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/streamers" element={<Streamers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/gta4-challenge" element={<GTA4Challenge />} />
              <Route path="/gta6-challenge" element={<GTA6Challenge />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminGuard />}>
                <Route element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="catalog" element={<AdminTools />} />
                  <Route path="tool-pages" element={<AdminToolPages />} />
                  <Route path="stream-pages" element={<AdminStreamPages />} />
                  <Route path="reviews" element={<AdminReviews />} />
                  <Route path="pages" element={<AdminPages />} />
                  <Route path="schedule" element={<AdminSchedule />} />
                  <Route path="streamers" element={<AdminStreamers />} />
                  <Route path="media" element={<AdminMedia />} />
                  <Route path="settings" element={<AdminSettings />} />
                </Route>
              </Route>
              <Route path="/:pageSlug" element={<StreamSubPageRoute />} />
            </Routes>
          </MaintenanceGate>
        </Router>
      </SiteSettingsProvider>
    </ThemeProvider>
  );
}

export default App;
